<div class="sp-folders-container" data-testid="sharepoint-folders-container">
    <aumico-integration-sharepoint-folders
        [providers]="visibleProviders"
        [selectedProviderId]="selectedProviderId"
        [connection]="(viewConnection$ | async) || defaultConnection"
        [folders]="(folders$ | async) || []"
        [requestedPermissions]="requestedPermissions"
        [addFolderErrorKey]="addFolderErrorKey$ | async"
        (selectProvider)="onSelectProvider($event)"
        (connect)="onConnect()"
        (allowConsent)="onAllowConsent()"
        (cancelConsent)="onCancelConsent()"
        (addFolder)="onAddFolder()"
        (removeFolder)="onRemove($event)"
        (toggleSubfolders)="onToggleSubfolders($event)"
    ></aumico-integration-sharepoint-folders>
</div>
